module.exports = __webpack_public_path__ + "img/Cap.79ceab94.png";